import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import { useGlobal } from '@/utils/useGlobal';

export default function IndexDynamic({ open, callback }: any) {
    const { useState, useEffect } = useGlobal();
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C />
            <D />
            <E open={open} callback={callback} />
            {open && (
                <>
                    <F />
                    <G />
                    <H />
                    <J />
                    <K />
                </>
            )}
            <L />
            <EmailSubscribe locale="jp" className="email-subscribe" pageType={PAGE_TYPE.Vanlife} entry_position={6} />
            <M />
        </>
    );
}
